import axios from 'axios'
import { getAPIService } from '../../getServerHost'

export const getWards = async () => {
  const response = await axios.get(`${getAPIService}/groups`)
  return response.data
}
